export default __webpack_public_path__ + "locales/pt-BR/ConnectDialog.json?hash=7b851e22dedb36ba1d4d5a9798506f6f";